<template>
    <div class="setScorePage">
        <div class="pageCont">
            <!-- <div class="item" v-for="(type,index) in allType" :key="index">
                <p class="title">{{(index+1) +"、"+type.name}}</p>
                <p class="uniteStyle">
                    （共
                    <span>{{type.data.length}}</span>
                    道题，每题统一设为：
                    <input type="text" onkeyup="this.value=this.value.replace(/\D/g,'')" @change="changeUniteScore(type,type.uniteScore)" v-model="type.uniteScore">
                    分）
                </p>
                <div class="cont">
                    <span class="cont-item" v-for="(data,indexD) in type.data" :key="indexD">
                        <span>{{(indexD+1) + "."}}</span>
                        <input type="text" @change="changeScore(type,data.score)" v-model="data.score" onkeyup="this.value=this.value.replace(/\D/g,'')">分
                    </span>
                </div>
            </div> -->
        </div>

        <div class="bottom-button">
            <a-button type="primary" @click="setSubmit">确定</a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'setScore',
    props: {
        pageList: {
            type: Array
        }
    },
    data () {
        return {
            allType: []
        }
    },

    methods: {
        getData () {
            var data = this.pageList
            console.log(this.pageList)
            // var typeData = [{ id: data[0].questionTypeId, name: data[0].questionTypeName }]
            var arr = this.pageList,
                result = [],
                len = arr.length;
            for (var i = 0; i < len; i++) {
                for (var j = i + 1; j < len; j++) {
                    if (arr[i].questionTypeId === arr[j].questionTypeId) {
                        j = ++i;
                    }
                }
                result.push({ id: arr[i].questionTypeId, name: arr[i].questionTypeName, data: [], uniteScore: '' });
            }

            for (let [k, v] of Object.entries(data)) {
                for (var d = 0; d < result.length; d++) {
                    if (result[d].id == v.questionTypeId) {
                        result[d].data.push(v)
                        console.log(k)
                    }
                }
            }
            this.allType = result
        },

        changeUniteScore (item, uniteScore) {
            if (uniteScore) {
                this.pageList.forEach(i => {
                    if (i.questionTypeId == item.id) {
                        i.score = uniteScore
                    }
                })
            }
        },
        changeScore (item, score) {
            console.log('item', item)
            console.log('score', score)
            item.data.forEach(i => {
                if (i.score != score) {
                    item.uniteScore = ""
                }
            })
            console.log('this.allType2', this.allType)
            console.log('this.pageList2', this.pageList)
        },

        setSubmit () {
            var data = JSON.stringify(this.pageList)
            localStorage.setItem('pageList', data)
            this.$emit('incre')
        },

    },
    created () {
        this.getData()
    }
}
</script>

<style scoped>
.setScorePage {
    position: relative;
}
.setScorePage .bottom-button {
    text-align: center;
    padding: 10px 0;
}

.pageCont {
    width: 100%;
    height: 300px;
    padding: 20px;
    overflow-y: scroll;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2) inset;
}
.pageCont .item {
    width: 100%;
    height: auto;
    position: relative;
    border-top: 1px solid #e5e5e5;
    padding: 10px;
}
.pageCont .item:first-child {
    border-top: none;
}
.pageCont .item .title {
    font-size: 15px;
    font-weight: 900;
}
.pageCont .item .uniteStyle {
    text-align: right;
    position: absolute;
    top: 10px;
    right: 10px;
}
.pageCont .item input {
    border: 1px solid #ccc;
    width: 30px;
    margin: 0 5px;
    padding-left: 12px;
    color: #000;
}
.pageCont .item .cont {
    margin-bottom: 10px;
}
.pageCont .item .cont .cont-item {
    margin-right: 20px;
}
.pageCont .item .cont .cont-item span {
    font-weight: bold;
}
</style>

